import { orderLineTotal } from './orderLineAmounts';
import { calculateMarginPercent } from './margin';

// Monetary totals in this module are integer kopiykas; API prices are UAH.
const cents = value => Math.round((Number(value) || 0) * 100);

export const getOrderProfit = order => {
  const lines = (order.orderItems || []).map(item => {
    const quantity = Number(item.quantity) || 0;
    // finalLineTotal already includes the allocated promo discount.
    const revenue = cents(
      item.finalLineTotal ?? orderLineTotal(item) - (Number(item.promoDiscountAmount) || 0),
    );
    const cost = cents((Number(item.purchasePrice) || 0) * quantity);
    // Prom supplies the commission for the whole line, including its quantity.
    const commission = cents(item.promCommission);
    const profit = revenue - cost - commission;
    return {
      item,
      quantity,
      revenue,
      cost,
      commission,
      profit,
      marginPercent: calculateMarginPercent(profit, revenue),
    };
  });
  const lineRevenue = lines.reduce((sum, line) => sum + line.revenue, 0);
  const revenue =
    order.finalTotal != null
      ? cents(order.finalTotal)
      : order.discountedPrice != null
      ? cents(order.discountedPrice)
      : lineRevenue;
  const cost = lines.reduce((sum, line) => sum + line.cost, 0);
  const commission = lines.reduce((sum, line) => sum + line.commission, 0);
  const delivery = cents(order.deliveryCost);
  const profit = revenue - cost - commission - delivery;
  return {
    lines,
    revenue,
    cost,
    commission,
    delivery,
    adjustment: revenue - lineRevenue,
    profit,
    marginPercent: calculateMarginPercent(profit, revenue),
  };
};

const money = new Intl.NumberFormat('uk-UA', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});
export const profitMoney = value => `${money.format(value === 0 ? 0 : value / 100)} грн`;
